import axios from 'axios';
import {
  BASE_URL
} from "../../config/env";

export const enterPriseBaseUrl = BASE_URL.TEST_HOST_API;

//共有接口---根据手机号带入用户信息
export const getUserInfo=(params)=>{
  let reqUrl='/api/v1/User/userByPhoneNumber'
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}

//企业用户首页接口
export const EnterpriseUserIndex = (params)=>{
    let reqUrl=`/api/Enterprise/EnterpriseUserIndex/enterPriseId/${params}`
    return axios({
        method: 'get',
        url: enterPriseBaseUrl + reqUrl,
    })
}

//企业管理员的所有产品和服务
export const EnterpriseUserProducts=(params)=>{
  let reqUrl='/api/Enterprise/EnterpriseAdminProducts'
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params,
  })
}

//企业管理员所有产品和服务设置备注
export const UpdateRemarksApi=(params)=>{
  let reqUrl=`/api/Enterprise/UpdateRemarks/mainId/${params.mainId}`
  return axios({
      method: 'patch',
      url: enterPriseBaseUrl + reqUrl,
      params:params,
  })
}



//个人成员查看的所有产品和服务
export const EnterprisePersonalUserProducts=(params)=>{
  let reqUrl='/api/Enterprise/EnterpriseUserProducts'
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params,
  })
}

//管理授权--按成员  获取成员列表
export const GrantSNToUser=(params)=>{
  let reqUrl='/api/Enterprise/GrantSNToUser'
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params,
  })
}


//管理授权--按成员  获取成员列表--分页和添加搜索条件
export const GrantSNToEnterpriseUserApi=(params)=>{
  let reqUrl='/api/Enterprise/GrantSNToEnterpriseUser'
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params,
  })
}

//管理授权--按成员 获取具体成员姓名、部门等信息
export const GetUserInviteInfo=(params)=>{
  let reqUrl=`/api/Enterprise/GetUserInviteInfo/userId/${params.userId}`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params.enterPriseId
  })
}

//管理授权--按成员  获取个人已经分配授权的产品
export const GetGrantSNProductInfo =(params)=>{
  //let reqUrl=`/api/Enterprise/GetGrantSNProductInfo/userId/${params.userId}`
  let reqUrl=`/api/Enterprise/GetGrantSNProductInfo/userId/${params.userId}`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params.enterPriseId
  })
}

//管理授权--按成员  给企业成员分配授权
export const GrantSNToEnterpriseUser=(params)=>{
  let reqUrl=`/api/Enterprise/GrantSNToEnterpriseUser`
  return axios({
      method: 'patch',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}
//新增 管理授权--按成员  给多个企业成员分配授权
export const BatchGrantSNToEnterpriseUser=(params,data)=>{
  let reqUrl=`/api/Enterprise/BatchGrantSNToEnterpriseUser`
  return axios({
      method: 'patch',
      url: enterPriseBaseUrl + reqUrl,
      params:params,
      data:data
  })
}

//管理授权--按成员  给多个企业成员分配SAAS授权
export const BatchGrantSAASToEnterpriseUser=(params,data)=>{
  let reqUrl=`/api/Enterprise/BatchGrantSAASToEnterpriseUser`
  return axios({
      method: 'patch',
      url: enterPriseBaseUrl + reqUrl,
      params:params,
      data:data
  })
}


//管理授权--按成员 给成员取消某个产品授权
export const CancelSN=(params)=>{
  let reqUrl=`/api/Enterprise/CancelSN`
  return axios({
      method: 'patch',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}
//新增 管理授权 --按成员 取消某个成员多个产品的授权
export const BatchCancelSN=(data)=>{
  let reqUrl=`/api/Enterprise/BatchCancelSN`
  return axios({
      method: 'patch',
      url: enterPriseBaseUrl + reqUrl,
      data:data
  })
}

//新增 管理授权 --按成员 取消某个成员多个产品的SAAS授权
export const BatchCancelSAAS=(data)=>{
  let reqUrl=`/api/Enterprise/BatchCancelSAAS`
  return axios({
      method: 'patch',
      url: enterPriseBaseUrl + reqUrl,
      data:data
  })
}

//管理授权--按成员 获取分配授权列表
export const GrantSNList =(params)=>{
  let reqUrl=`/api/Enterprise/GrantSNList`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}

//管理授权--按成员 企业管理员获取用户头像
export const AdminGetUserHeadImageApi =(params)=>{
  let reqUrl=`/api/Enterprise/GetUserHeadImage`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}


//管理授权--按产品  获取该企业所有产品列表
export const GrantSNByProduct =(params)=>{
  let reqUrl=`/api/Enterprise/GrantSNByProduct`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}


// 获取成员列表
export const UserList =(params)=>{
  let reqUrl=`/api/Enterprise/EnterpriseUserList`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}
//获取成员列表分页
// 获取成员列表
export const GetEnterpriseUserListApi =(params)=>{
  let reqUrl=`/api/Enterprise/GetEnterpriseUserList`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}



//管理授权-按产品  获取该产品已分配授权成员
export const GetSNGrantedUsersApi =(params)=>{
  let reqUrl=`/api/Enterprise/GetSNGrantedUsers`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}

//管理授权-按产品  获取该产品已分配授权成员--分页接口
export const GetPagedSNGrantedUsersApi =(params)=>{
  let reqUrl=`/api/Enterprise/GetPagedSNGrantedUsers/mainId/${params.mainId}/pageIndex/${params.pageIndex}/pageSize/${params.pageSize}`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}


//管理授权--按产品 取消该产品某个成员的授权
export const CancelProductSNApi =(params)=>{
  let reqUrl=`/api/Enterprise/CancelProductSN`
  return axios({
      method: 'patch',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}
//管理授权 --按产品 取消该产品多个成员的授权
export const CancelUsersProductSNApi =(params,data)=>{
  let reqUrl=`/api/Enterprise/CancelUsersProductSN`
  return axios({
      method: 'patch',
      url: enterPriseBaseUrl + reqUrl,
      params:params,
      data:data
  })
}

//管理授权 --按产品 取消该产品多个成员的SAAS授权
export const CancelUsersSAASApi =(params,data)=>{
  let reqUrl=`/api/Enterprise/CancelUsersSAAS`
  return axios({
      method: 'patch',
      url: enterPriseBaseUrl + reqUrl,
      params:params,
      data:data
  })
}

//管理授权--按产品 只显示未分配授权的用户
export const GetSNUnGrantedUsersApi =(params)=>{
  let reqUrl=`/api/Enterprise/GetSNUnGrantedUsers`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}

//管理授权--按产品 只显示未分配授权的用户 --增加加入时间字段排序
export const GetSNUnGrantedEnterpriseUsersApi =(params)=>{
  let reqUrl=`/api/Enterprise/GetSNUnGrantedEnterpriseUsers`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}

//管理授权--按产品 获取产品授权信息
export const GetProductGrantInfoApi =(params)=>{
  let reqUrl=`/api/Enterprise/GetProductGrantInfo`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}

//管理授权-- 按产品 给成员分配授权
export const  GrantProductToUserApi=(params)=>{
  let reqUrl=`/api/Enterprise/GrantProductSNToEnterpriseUser`
  return axios({
      method: 'patch',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}
//新增 管理授权-- 按产品 给多个成员分配授权
export const  GrantProductToMultiUserApi=(params,data)=>{
  let reqUrl=`/api/Enterprise/GrantProductSNToEnterpriseUsers`
  return axios({
      method: 'patch',
      url: enterPriseBaseUrl + reqUrl,
      params:params,
      data:data
  })
}

//新增 管理授权-- 按产品 给多个成员分配SAAS产品授权
export const  BatchGrantSAASToEnterpriseUserApi=(params,data)=>{
  let reqUrl=`/api/Enterprise/GrantSAASToEnterpriseUsers`
  return axios({
      method: 'patch',
      url: enterPriseBaseUrl + reqUrl,
      params:params,
      data:data
  })
}

//获取用户所在企业
export const UserIsMemberOfEnterprises=(params)=>{
  let reqUrl=`/api/Enterprise/UserIsMemberOfEnterprises`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
  })
}

//个人用户主页
export const PersonalUserIndex=(params)=>{
  let reqUrl='/api/Enterprise/PersonalUserIndex'
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
  })
}

/*成员管理相关*/
//邀请单个用户
export const InviteSingleUser=(data)=>{
  let reqUrl='/api/Enterprise/InviteSingleUser'
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      data:data
  })
}

//邀请多个用户
export const InviteMultipleUser=(data)=>{
  let reqUrl='/api/Enterprise/InviteMultipleUser'
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      data:data
  })
}

//删除单个用户
export const DeleteEnterpriseUser=(params)=>{
  let reqUrl='/api/Enterprise/DeleteEnterpriseUser'
  return axios({
      method: 'delete',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}
//删除多个用户
export const BatchDeleteEnterpriseUsers=(params,data)=>{
  let reqUrl='/api/Enterprise/BatchDeleteEnterpriseUsers'
  return axios({
      method: 'delete',
      url: enterPriseBaseUrl + reqUrl,
      params:params,
      data:data
  })
}
//移交管理员
export const ChangeAdmin=(params)=>{
  let reqUrl='/api/Enterprise/ChangeAdmin'
  return axios({
      method: 'patch',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}
//查看成员邀请记录
export const InviteUserList=(params)=>{
  let reqUrl='/api/Enterprise/InviteUserListV2'
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}
//下载模板接口
export const DownLoadTemplateApi=(params)=>{
  let reqUrl='/api/Enterprise/DownLoadTemplate'
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      responseType:'blob'
  })
}


/* 企业信息菜单相关*/
//查看历史认证记录
export const AuditHistoryList=(params)=>{
  let reqUrl='/api/Enterprise/AuditHistoryList'
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}
//提交企业信息审核
export const SubmotAudit=(data)=>{
  let reqUrl='/api/Enterprise/AuditHistoryList'
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      data:data
  })
}
//获取企业详细信息
export const enterPriseDetailInfo=(params)=>{
  let reqUrl='/api/Enterprise/GetEnterpriseInfoByIdAsync'
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params,
  })
}
//提交或者更新时检查企业同名是否存在
export const Canuse=(params)=>{
  let reqUrl='/api/Enterprise/CanUseWhenSubmit'
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params,
  })
}

//提交或者更新时检查企业同名是否存在
export const checkReNameApi=(params)=>{
  let reqUrl='/api/Enterprise/CanUse'
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params,
  })
}

//提交个人信息审核
export const PersonalSubmitAuditApi=(params)=>{
  let reqUrl='/api/Enterprise/PersonalSubmitAudit'
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
  })
}

//企业管理员查看saas产品
export const SaasEnterpriseAdminProductsApi=(params)=>{
  let reqUrl='/api/Enterprise/SaasEnterpriseAdminProducts'
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}

//企业成员查看sass产品
export const SaasEnterpriseUserProductsApi=(params)=>{
  let reqUrl='/api/Enterprise/SaasEnterpriseUserProducts'
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}

//查看当前并发数用户信息
export const ShowConcurrentCountApi=(params)=>{
  let reqUrl='/api/Enterprise/ShowConcurrentCount'
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}

//更新成员真实信息
export const EditUsersInfoByPhoneApi=(params)=>{
  let reqUrl='/api/Enterprise/EditUsersRealNameAndDepartmentByPhone'
  return axios({
      method: 'patch',
      url: enterPriseBaseUrl + reqUrl,
      data:params
  })
}

//更新成员真实信息--关联部门
export const EditUserConnectionNameAndDepartmentApi=(params)=>{
  let reqUrl='/api/Enterprise/EditUserConnectionNameAndDepartment'
  return axios({
      method: 'patch',
      url: enterPriseBaseUrl + reqUrl,
      data:params
  })
}

//批量根据手机号获取成员姓名
export const GetUsersRealNameByPhoneApi=(params)=>{
  let reqUrl='/api/Enterprise/GetUsersRealNameByPhone'
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      data:params
  })
}

//判断当前账号是否是企业管理员
export const IsAdminApi=(params)=>{
  let reqUrl='/api/Enterprise/IsAdmin'
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}

//判断当前账号是否是企业管理员
export const SetClientUserForceOffLineApi=(params)=>{
  let reqUrl=`/api/Enterprise/SetClientUserForceOffLine/userPhone/${params.userPhone}/sn/${params.sn}`
  return axios({
      method: 'put',
      url: enterPriseBaseUrl + reqUrl,
  })
}


//第四期需求部门管理
//获取部门列表接口
export const GetEnterpriseDepartmentApi=(params)=>{
  let reqUrl=`/api/Enterprise/GetEnterpriseDepartment`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}

//获取增加部门接口
export const CreateEnterpriseDepartmentApi=(data)=>{
  let reqUrl=`/api/Enterprise/CreateEnterpriseDepartment`
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      data:data
  })
}

//删除部门接口
export const DeleteEnterpriseDepartmentApi=(params)=>{
  let reqUrl=`/api/Enterprise/DeleteEnterpriseDepartment`
  return axios({
      method: 'delete',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}

//编辑部门接口
export const EditEnterpriseDepartmentApi=(data)=>{
  let reqUrl=`/api/Enterprise/EditEnterpriseDepartment`
  return axios({
      method: 'patch',
      url: enterPriseBaseUrl + reqUrl,
      data:data
  })
}

//移动成员到新部门
export const UpdateEnterpriseInfoAndUserListApi=(params,data)=>{
  let reqUrl=`/api/Enterprise/UpdateEnterpriseInfoAndUserList`
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      params:params,
      data:data
  })
}

//批量邀请成员，反馈失败原因数集
export const InviteMultipleUserRetReasonApi=(data)=>{
  let reqUrl=`/api/Enterprise/InviteMultipleUserRetReasonV2`
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      data:data
  })
}

//批量导入模板
export const UploadTemplateRetReasonApi=(data)=>{
  let reqUrl=`/api/Enterprise/UploadTemplateRetReasonV2`
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      data:data
  })
}

//创建用户邀请链接
export const CreateInviteUserLinkApi=(params)=>{
  let reqUrl=`/api/Enterprise/CreateInviteUserLink`
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}

//解析邀请的链接信息
export const GetDecryptInviteUserLinkDataApi=(params)=>{
  let reqUrl=`/api/Enterprise/GetDecryptInviteUserLinkData`
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      params:params
  })
}

//用户申请加入企业
export const CreateUserInviteEnterpriseApi=(data)=>{
  let reqUrl=`/api/v1/User/CreateUserInviteEnterprise`
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      data
  })
}

//用户申请加入企业列表
export const UserInviteListApi=(params)=>{
  let reqUrl=`/api/Enterprise/UserInviteList`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params
  })
}

//查看用户申请详情
export const GetInviteUserByIdApi=(params)=>{
  let reqUrl=`/api/Enterprise/GetInviteUserById`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params
  })
}

//管理员审核用户申请
export const AuditInviteUserApi=(data)=>{
  let reqUrl=`/api/Enterprise/AuditInviteUser`
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      data
  })
}

//批量审核用户申请
export const AuditMultipleInviteUserApi=(data)=>{
  let reqUrl=`/api/Enterprise/AuditMultipleInviteUser`
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      data
  })
}

//获取用户引导提醒
export const GetNotificationsRecordApi=(params)=>{
  let reqUrl=`/api/Enterprise/GetNotificationsRecord`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params
  })
}

//创建用户引导提醒
export const CreateNotificationsRecordApi=(params)=>{
  let reqUrl=`/api/Enterprise/CreateNotificationsRecord`
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      params
  })
}


//获取用户关联的企业
export const GetEnterpriseSelectedListApi=()=>{
  let reqUrl=`/api/Enterprise/GetEnterpriseSelectedList`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
  })
}


//查询部门下的用户信息
export const GetDepartmentAndUserApi=(params)=>{
  let reqUrl=`/api/Enterprise/GetDepartmentAndUser`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params
  })
}

//查询部门授权分拨列表
export const GetDepartmentSNGrantedApi=(params)=>{
  let reqUrl=`/api/Enterprise/GetDepartmentSNGranted`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params
  })
}

//查询产品授权分拨列表
export const GetProductSNGrantedApi=(params)=>{
  let reqUrl=`/api/Enterprise/GetProductSNGranted`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params
  })
}

//获取当前企业超级管理员信息
export const GetAdminUserApi=(params)=>{
  let reqUrl=`/api/Enterprise/GetAdminUser`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params
  })
}

//转让超级管理员时获取成员列表
export const GetAdminSelectUserListApi=(params)=>{
  let reqUrl=`/api/Enterprise/GetAdminSelectUserList`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params
  })
}

//添加管理组时候添加子管理员的菜单 
export const GetAdminStartMenuApi=(params)=>{
  let reqUrl=`/api/Enterprise/GetAdminStartMenu`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params
  })
}

//创建管理组 
export const CreateRightsManagementGroupApi=(data)=>{
  let reqUrl=`/api/Enterprise/CreateRightsManagementGroup`
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      data
  })
}

//查询管理组
export const GetRightsManagementGroupApi=(params)=>{
  let reqUrl=`/api/Enterprise/GetRightsManagementGroup`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params
  })
}

//根据id查询管理组详情
export const GetRightsManagementGroupByIdApi=(params)=>{
  let reqUrl=`/api/Enterprise/GetRightsManagementGroupById`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params
  })
}


//删除管理组
export const DeleteRightsManagementGroupApi=(params)=>{
  let reqUrl=`/api/Enterprise/DeleteRightsManagementGroup`
  return axios({
      method: 'delete',
      url: enterPriseBaseUrl + reqUrl,
      params
  })
}

//编辑管理组
export const EditRightsManagementGroupApi=(data)=>{
  let reqUrl=`/api/Enterprise/EditRightsManagementGroup`
  return axios({
      method: 'patch',
      url: enterPriseBaseUrl + reqUrl,
      data
  })
}

//授权分拨接口
export const SNGrantedAllocateApi=(data)=>{
  let reqUrl=`/api/Enterprise/SNGrantedAllocate`
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      data
  })
}

//授权回收接口
export const SNGrantedRecycleApi=(data)=>{
  let reqUrl=`/api/Enterprise/SNGrantedRecycle`
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      data
  })
}

//删除部门前，获取部门状态，是否有授权，是否有子管理员，有的话不能删除。
export const GetEnterpriseDepartmentStatusApi=(params)=>{
  let reqUrl=`/api/Enterprise/GetEnterpriseDepartmentStatus`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params
  })
}

//移动成员时候，获取成员状态，是否有授权，是否是子管理员，有授权不能移动，有子管理员不能移动
export const GetEnterpriseUserStatusApi=(data)=>{
  let reqUrl=`/api/Enterprise/GetEnterpriseUserStatus`
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      data,
  })
}

//按成员 分配授权时候，需要看成员所在的部门是否有授权、否则将从上级部门中分配
export const GetUserSnInDepartmentApi=(data)=>{
  let reqUrl=`/api/Enterprise/GetUserSnInDepartment`
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      data,
  })
}

//按产品 分配授权时候，需要看成员所在的部门是否有授权、否则将从上级部门中分配
export const GetProductSnInDepartmentApi=(data)=>{
  let reqUrl=`/api/Enterprise/GetProductSnInDepartment`
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      data,
  })
}


//获取删除企业时候的验证码
export const GetVerificationCodeApi=(data)=>{
  let reqUrl=`/api/Enterprise/GetVerificationCode`
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      data,
  })
}

//注销企业账户
export const CancelEnterpriseAccountApi=(data)=>{
  let reqUrl=`/api/Enterprise/CancelEnterpriseAccount`
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      data,
  })
}

//预注销企业账号 注销前检查有无有效期的产品
export const PreCancelEnterpriseAccountApi=(data)=>{
  let reqUrl=`/api/Enterprise/PreCancelEnterpriseAccount`
  return axios({
      method: 'post',
      url: enterPriseBaseUrl + reqUrl,
      data,
  })
}

export const NotifyAuditPassedApi=(params)=>{
  let reqUrl=`/api/v1/User/Notify-OnCancelAuditPassed`
  return axios({
      method: 'get',
      url: enterPriseBaseUrl + reqUrl,
      params
  })
}

//获取企业管理员订单列表
export const EnterpriseOrderListApi = (params) => {
  return axios({
    method: 'get',
    url: enterPriseBaseUrl + `/api/Enterprise/EnterpriseOrderList`,
    params:params
  })
}

//获取管理员订单详情
export const GetEnterpriseOrderDetailsApi = (params) => {
  return axios({
    method: 'get',
    url: enterPriseBaseUrl + `/api/Enterprise/GetEnterpriseOrderDetails/orderNo/${params}`,
  })
}

//删除管理员订单
export const DeleteEnterpriseOrderApi=(params)=>{
  return axios({
    method: 'delete',
    url: enterPriseBaseUrl + `/api/Enterprise/DeleteEnterpriseOrder/orderNo/${params}`,
  })
}

//取消管理员订单
export const CancelEnterpriseOrderApi = (params) => {
  return axios({
    method: 'get',
    url: enterPriseBaseUrl + `/api/Enterprise/CancelEnterpriseOrder/orderNo/${params}`,
  })
}

//获取授权码使用记录
export const GetEnterpriseSnUsedRecordsApi = (data) => {
  return axios({
    method: 'post',
    url: enterPriseBaseUrl + `/api/Enterprise/GetEnterpriseSnUsedRecords`,
    data
  })
}

//接口-按钮开关记录
export const UpdatePageStatusRecordApi = (data) => {
  return axios({
    method: 'post',
    url: enterPriseBaseUrl + `/api/v1/User/UpdatePageStatusRecord`,
    data
  })
}

//接口-按钮开关记录
export const GetPageStatusRecordApi = (params) => {
  return axios({
    method: 'get',
    url: enterPriseBaseUrl + `/api/v1/User/GetPageStatusRecord`,
    params
  })
}


























// WEBPACK FOOTER //
// ./src/js/enterPriseApi.js